/** @format */

import template from './gb-edit-text-widget.html';
import './gb-edit-text-widget.scss';

export const GbEditTextWidgetComponent = {
    template,
    require: {
        gbEditTools: '^^',
    },
    bindings: {
        widget: '=',
    },
    controller: class GbEditTextWidgetComponent {
        constructor() {
            'ngInject';
        }

        getWidget() {
            return this.widget;
        }
    },
};
